import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const namespace = 'features';
export const keyPrefix = 'reset_user_password';
export const useResetUserPasswordTranslation = (): UseTranslationResponse<
  typeof namespace,
  typeof keyPrefix
> => useTranslation(namespace, { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    button: 'Сбросить',

    modal_title: 'Сброс пароля',
    modal_subtitle: 'Пароль будет сброшен. Выберите способ получения ссылки на установку нового пароля.',
    modal_email_button: 'Отправить ссылку на email пользователя',
    modal_confirmation_button: 'Получить ссылку здесь',
    modal_cancel_button: 'Отмена',

    confirm_title: 'Сброс пароля',
    confirm_description: 'Пароль сброшен. Отправьте ссылку на установку нового пароля.',
    confirm_link: 'Ссылка',
    confirm_button: 'Понятно',

    toast_success: 'Ссылка скопирована',
    toast_error: 'Не удалось сбросить пароль',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    button: 'Reset',

    modal_title: 'Reset password',
    modal_subtitle: 'The password will be reset. Choose how to receive the link to set a new password.',
    modal_email_button: "Send link to user's email",
    modal_confirmation_button: 'Get the link here',
    modal_cancel_button: 'Cancel',

    confirm_title: 'Reset password',
    confirm_description: 'Password has been reset. Send the link to set a new password.',
    confirm_link: 'Link',
    confirm_button: 'Got it',

    toast_success: 'Link copied',
    toast_error: 'Failed to reset password',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    button: 'Redefinir',

    modal_title: 'Redefinir senha',
    modal_subtitle: 'A senha será redefinida. Escolha como receber o link para definir uma nova senha.',
    modal_email_button: 'Enviar link para o e-mail do usuário',
    modal_confirmation_button: 'Obter o link aqui',
    modal_cancel_button: 'Cancelar',

    confirm_title: 'Redefinir senha',
    confirm_description: 'A senha foi redefinida. Envie o link para definir uma nova senha.',
    confirm_link: 'Link',
    confirm_button: 'Entendi',

    toast_success: 'Link copiado',
    toast_error: 'Falha ao redefinir a senha',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    button: 'Restablecer',

    modal_title: 'Restablecer contraseña',
    modal_subtitle: 'La contraseña se restablecerá. Elija cómo recibir el enlace para establecer una nueva contraseña.',
    modal_email_button: 'Enviar enlace al correo del usuario',
    modal_confirmation_button: 'Obtener el enlace aquí',
    modal_cancel_button: 'Cancelar',

    confirm_title: 'Restablecer contraseña',
    confirm_description: 'La contraseña ha sido restablecida. Envíe el enlace para establecer una nueva contraseña.',
    confirm_link: 'Enlace',
    confirm_button: 'Entendido',

    toast_success: 'Enlace copiado',
    toast_error: 'Error al restablecer la contraseña',
  },
}) as Record<string, unknown>;
